import { z } from 'zod';

// Schema para informações do cliente
export const customerInfoSchema = z.object({
  firstName: z.string()
    .min(1, 'Informe seu primeiro nome')
    .max(50, 'Use no máximo 50 caracteres no primeiro nome'),
  
  lastName: z.string()
    .min(1, 'Informe seu sobrenome')
    .max(50, 'Use no máximo 50 caracteres no sobrenome'),
  
  email: z.string()
    .min(1, 'Informe seu e-mail')
    .max(100, 'Use no máximo 100 caracteres no e-mail')
    .email('Digite um e-mail válido, como nome@exemplo.com'),
  
  phone: z.string()
    .min(1, 'Informe seu telefone')
    .regex(/^[\d\s()\-+]+$/, 'Use apenas números, espaços e símbolos como + ou ()')
    .min(10, 'Inclua DDD + número, com pelo menos 10 dígitos'),
});

export type CustomerInfoFormData = z.infer<typeof customerInfoSchema>;
